import { Link } from "@tanstack/react-router";
import * as stylex from "@stylexjs/stylex";
import { pillProps } from "@/components/ui/Button";
import CenteredCard from "@/components/ui/CenteredCard";
import "@/design/tokens.stylex";
import { colors, space, text } from "@/design/tokens.stylex";

// The page for an address the app does not have. Inside a Company an unknown
// address opens the Company's default page instead (see
// routes/_authenticated/$orgSlug.tsx). The way back is the bare entry, which
// resolves to the person's Last place.

export default function NotFoundPage() {
  return <CenteredCard>
      <h1 className="x1ghz6dp xuxpmqx xk50ysn xgwkh9f">This page doesn’t exist</h1>
      <p className="x1ghz6dp xtu3avg x1evy7pa x1e3avs9">The link may be old, or the page has moved.</p>
      <div className="x78zum5 x13a6bvl x11j7w4t">
        <Link to="/" {...pillProps({
        variant: "primary"
      })}>
          Go to Growth Engine
        </Link>
      </div>
    </CenteredCard>;
}